var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountShape({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99265 10.9953L1.85266 9.85531C1.38766 9.39031 1.38766 8.6253 1.85266 8.1603L2.99265 7.02029C3.18765 6.82529 3.34515 6.44279 3.34515 6.17279V4.56027C3.34515 3.90027 3.88515 3.36029 4.54515 3.36029H6.15765C6.42765 3.36029 6.81015 3.20281 7.00515 3.00781L8.14514 1.86779C8.61014 1.40279 9.37515 1.40279 9.84015 1.86779L10.9802 3.00781C11.1752 3.20281 11.5576 3.36029 11.8276 3.36029H13.4402C14.1002 3.36029 14.6401 3.90027 14.6401 4.56027V6.17279C14.6401 6.44279 14.7976 6.82529 14.9926 7.02029L16.1327 8.1603C16.5977 8.6253 16.5977 9.39031 16.1327 9.85531L14.9926 10.9953C14.7976 11.1903 14.6401 11.5728 14.6401 11.8428V13.4553C14.6401 14.1153 14.1002 14.6553 13.4402 14.6553H11.8276C11.5576 14.6553 11.1752 14.8128 10.9802 15.0078L9.84015 16.1478C9.37515 16.6128 8.61014 16.6128 8.14514 16.1478L7.00515 15.0078C6.81015 14.8128 6.42765 14.6553 6.15765 14.6553H4.54515C3.88515 14.6553 3.34515 14.1153 3.34515 13.4553V11.8428C3.34515 11.5653 3.18765 11.1828 2.99265 10.9953Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25L11.25 6.75",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8709 10.875H10.8776",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12088 7.125H7.12762",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discount-shape.bd034dba835fd8a7e9f17657c4008fce.svg";
export { ForwardRef as ReactComponent };